import(/* webpackMode: "eager", webpackExports: ["toast","isActive","error"] */ "/codebuild/output/src2126065393/src/stage-webapp/node_modules/react-toastify/dist/react-toastify.esm.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["LayoutCSR"] */ "/codebuild/output/src2126065393/src/stage-webapp/src/components/LayoutCSR.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RegisterEventListeners"] */ "/codebuild/output/src2126065393/src/stage-webapp/src/components/RegisterEventListeners.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalProvider"] */ "/codebuild/output/src2126065393/src/stage-webapp/src/context/GlobalProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StringsProvider"] */ "/codebuild/output/src2126065393/src/stage-webapp/src/context/StringsProvider.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2126065393/src/stage-webapp/src/utils/firebaseConfig.ts");
